import React, { Ref } from "react";

import { StrainRelatives } from "custom-types/StrainV2";

import StrainLineageLink from "./StrainLineageLink";

type Props = {
  parent1Ref: Ref<HTMLDivElement>;
  parent2Ref: Ref<HTMLDivElement>;
  parents: StrainRelatives;
};

const StrainLineageTwoParents = ({
  parent1Ref,
  parent2Ref,
  parents,
}: Props) => (
  <>
    <div className="col-[1/3] row-[1/3] w-[80px]" ref={parent1Ref}>
      <StrainLineageLink
        strain={parents[0]}
        altText="First strain parent"
        parentOrChild="parent"
      />
    </div>
    {parents[1] && (
      <div className="col-[5/7] row-[1/3] w-[80px]" ref={parent2Ref}>
        <StrainLineageLink
          strain={parents[1]}
          altText="Second strain parent"
          parentOrChild="parent"
        />
      </div>
    )}
  </>
);

export default StrainLineageTwoParents;
